import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpDriverFormData } from "../types";

export const DriversLicenseField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpDriverFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Driver&apos;s License</Typography>
      <TextInput className="w-full" hasError={!!errors.driverLicense} placeholder="00000" maxLength={45} {...register("driverLicense")} />
      <ErrorMessage errors={errors} name="driverLicense" />
    </div>
  );
};
